import messagesESES from '../translations/es_es.json';
import messagesESMX from '../translations/es_mx.json';
import messagesESPY from '../translations/es_py.json';
import messagesESUY from '../translations/es_uy.json';
import messagesESCO from '../translations/es_co.json';
import messagesPTBR from '../translations/pt_br.json';
import messagesPTPT from '../translations/pt_pt.json';

const messagesByLanguage = {
  ES: messagesESES,
  MX: messagesESMX,
  UY: messagesESUY,
  PY: messagesESPY,
  CO: messagesESCO,
  BR: messagesPTBR,
  PT: messagesPTPT,
};

const localeByLanguage = {
  MX: 'es-MX',
  UY: 'es-UY',
  CO: 'es-CO',
  PY: 'es-PY',
  ES: 'es-ES',
  BR: 'pt-BR',
  PT: 'pt-PT',
};

function getUserLanguage(language = 'BR') {
  try {
    return {
      locale: localeByLanguage[language],
      messages: messagesByLanguage[language],
    };
  } catch {
    return {
      locale: localeByLanguage.BR,
      messages: messagesByLanguage.BR,
    };
  }
}

export default getUserLanguage;
